var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: {
        centerScreen: "",
        bus: _vm.busModal,
        persistent: "",
        centerAndDecreasesPadding: "",
        maxWidth: "500px",
        backgroundColor: "white"
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "d-flex mt-4 az-gap-small" },
                [
                  _c(
                    "BaseButton",
                    { attrs: { underlined: "" }, on: { click: close } },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "BaseButton",
                    {
                      attrs: { primary: "", loading: _vm.loading },
                      on: { click: _vm.save }
                    },
                    [_vm._v(" Salvar ")]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _c("div", { staticClass: "pb-6" }, [
        _c("div", { staticClass: "modal-title-container" }, [
          _c("span", { staticClass: "modal-title" }, [
            _vm._v("Alterar cliente vinculado")
          ])
        ]),
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c(
              "BaseValidationForm",
              { ref: "form" },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "d-flex flex-column py-1",
                        attrs: { cols: "12" }
                      },
                      [
                        _c("InputByType", {
                          staticClass: "align-icon-search",
                          attrs: {
                            type: "autocomplete",
                            options: _vm.clientOptions,
                            loading: _vm.loadingClients,
                            placeholder: "Selecione um cliente",
                            outlined: "",
                            clearable: "",
                            labelExternal: "Cliente *",
                            rules: [_vm.rules.required]
                          },
                          model: {
                            value: _vm.item.id_cliente,
                            callback: function($$v) {
                              _vm.$set(_vm.item, "id_cliente", $$v)
                            },
                            expression: "item.id_cliente"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }